import { CSSProperties, ReactNode } from 'react';
import { PlacesType, Tooltip } from 'react-tooltip';

interface IOpenEvents {
  mouseenter?: boolean;
  focus?: boolean;
  click?: boolean;
  dblclick?: boolean;
  mousedown?: boolean;
}

interface ICloseEvents {
  mouseleave?: boolean;
  blur?: boolean;
  click?: boolean;
  dblclick?: boolean;
  mouseup?: boolean;
}

interface IGlobalCloseEvents {
  escape?: boolean;
  scroll?: boolean;
  resize?: boolean;
  clickOutsideAnchor?: boolean;
}

interface IDropDown {
  id: string;
  className?: string;
  offset?: number;
  position: PlacesType;
  arrow?: boolean;
  onClick?: boolean;
  children: ReactNode;
  afterHide?: (status: boolean) => void;
  afterShow?: () => void;
  style?: CSSProperties;
  isOpen?: boolean;
  setIsOpen?: (open: boolean) => void;
  openEvents?: IOpenEvents;
  closeEvents?: ICloseEvents;
  globalCloseEvents?: IGlobalCloseEvents;
}

const DropDown: React.FC<IDropDown> = ({
  id,
  offset = 0,
  position,
  arrow = false,
  onClick = false,
  children,
  afterHide,
  afterShow,
  style,
  isOpen,
  setIsOpen,
  openEvents,
  closeEvents,
  globalCloseEvents,
  className
}) => {
  const styles: CSSProperties = {
    borderRadius: 8,
    zIndex: 99999,
    ...style,
  };

  return (
    <Tooltip
      clickable
      id={id}
      place={position}
      offset={offset}
      openOnClick={onClick}
      noArrow={arrow}
      afterHide={() => (afterHide ? afterHide(false) : {})}
      openEvents={openEvents}
      closeEvents={
        closeEvents ?? { click: onClick, mouseleave: onClick ? false : true }
      }
      globalCloseEvents={globalCloseEvents}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className={`tooltip shadow-level-4 sm:w-32 ${className}`}
      classNameArrow='tooltip-arrow'
      opacity={1}
      style={styles}
      afterShow={afterShow}
    >
      {children}
    </Tooltip>
  );
};

export default DropDown;
